import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";
import { TFinancialSummaryInterval } from "../../models/reports/financial-summary.model";

@Injectable()
export class FinancialSummaryService {
  private apiPrefix = '/admin/reports/financial-summary';

  constructor(
    private api: ApiService
  ) {
  }

  getFinancialSummary(interval: TFinancialSummaryInterval, startDate?: string, endDate?: string): Observable<any> {
    let qs = `?interval=${interval}`;

    if (startDate) {
      qs += `&start_date=${startDate}`;
    }

    if (endDate) {
      qs += `&end_date=${endDate}`;
    }

    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  createFinancialSummaryReport(body: { start_date?: string; end_date?: string }): Observable<any> {
    return this.api.post(this.apiPrefix, body);
  }
}
